'use client'

import {observer} from 'mobx-react'
// @ts-ignore
import {useRouter} from 'nextjs-toploader/app'
import React, {useEffect, useState} from 'react'

import {Routes} from '@/src/config/routes'

import {useStore} from '@/src/shared/hooks/useStore'
import {LoadingPage} from '@/src/shared/ui/layout/ui'

export const LoggedInAlreadyRedirect = observer(({children}: React.PropsWithChildren) => {
  const store = useStore()
  const router = useRouter()
  const [checkAuth, setCheckAuth] = useState(false)

  useEffect(() => {
    const authenticated = store.session?.user?.id

    if (authenticated) {
      const next = new URL(location.href).searchParams.get('next')
      if (next) {
        router.push(next)
      } else {
        router.push(Routes.profile.page)
      }
    } else {
      setCheckAuth(true)
    }
  }, [])

  if (!checkAuth) return <LoadingPage />
  return children
})
